import styled from 'styled-components';
import { useUser } from '../../data/use_user.tsx';
import { openProfileDrawer } from './profile_drawer_state.ts';
import { SettingsTip } from './settings_tip.tsx';

// Stable element id so tutorials can spotlight the header avatar
export const profileAvatarId = 'profile-avatar';

export function userInitial(name: string | undefined): string | undefined {
  return name?.trim().charAt(0).toUpperCase() || undefined;
}

// Circular avatar in the header's left slot on the main tabs; opens the profile drawer.
// Renders nothing before a household member has been chosen.
export const ProfileAvatar = () => {
  const { user } = useUser();
  const initial = userInitial(user?.name);
  if (!initial) {
    return null;
  }
  return (
    <AvatarWrapper>
      <AvatarCircle id={profileAvatarId} onClick={openProfileDrawer}>
        {initial}
      </AvatarCircle>
      <SettingsTip />
    </AvatarWrapper>
  );
};

// Relative wrapper anchors the one-time SettingsTip callout to the avatar
const AvatarWrapper = styled.div`
  position: relative;
  flex: none;
  margin-left: 12px;
`;

const AvatarCircle = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: var(--color-nightingale);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Jost-SemiBold, Arial, sans-serif;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
`;
